import React from 'react';
import { Modal, Row, Col, Descriptions } from 'antd';

const OrderDetails = ({ selectedOrder, setSelectedOrder, previewUrl }) => {
  if (!selectedOrder) return null;

  return (
    <Modal
      title="订单详情"
      open={!!selectedOrder}
      onCancel={() => setSelectedOrder(null)}
      footer={null}
      width="70%"
    >
      <Row gutter={24}>
        <Col span={14}>
          <Descriptions 
            column={1} 
            bordered 
            size="small"
            contentStyle={{ fontWeight: 400 }}
            labelStyle={{ fontWeight: 400 }}
            style={{ fontSize: '14px' }}
          >
            <Descriptions.Item label="订单号">{selectedOrder.order_number}</Descriptions.Item>
            <Descriptions.Item label="快递单号">{selectedOrder.express_number}</Descriptions.Item>
            <Descriptions.Item label="收件人">
              {selectedOrder.label_address ? (
                <span style={{ color: '#1890ff' }}>{selectedOrder.label_recipient}</span>
              ) : (
                selectedOrder.recipient_name
              )}
            </Descriptions.Item>
            <Descriptions.Item label="电话">
              {selectedOrder.label_address ? (
                <span style={{ color: '#1890ff' }}>{selectedOrder.label_phone}</span>
              ) : (
                selectedOrder.recipient_phone
              )}
            </Descriptions.Item>
            <Descriptions.Item label="地址">
              {selectedOrder.label_address ? (
                <span style={{ color: '#1890ff' }}>{selectedOrder.label_address}</span>
              ) : (
                selectedOrder.recipient_address
              )}
            </Descriptions.Item>
            {selectedOrder.recipient_company && (
              <Descriptions.Item label="公司">{selectedOrder.recipient_company}</Descriptions.Item>
            )}
            <Descriptions.Item label="品名">{selectedOrder.product_name || '-'}</Descriptions.Item>
            <Descriptions.Item label="单位">{selectedOrder.unit || '-'}</Descriptions.Item>
            <Descriptions.Item label="单件重量（KG）">{selectedOrder.weight_per_item || '-'}</Descriptions.Item>
            <Descriptions.Item label="数量">{selectedOrder.quantity || '-'}</Descriptions.Item>
            {selectedOrder.remark && (
              <Descriptions.Item label="备注">{selectedOrder.remark}</Descriptions.Item>
            )}
            <Descriptions.Item label="创建时间">
              {new Date(selectedOrder.created_at).toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              })}
            </Descriptions.Item>
          </Descriptions>
        </Col>
        <Col span={10} style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
          <div style={{ 
            backgroundColor: '#f5f5f5',
            padding: '20px',
            borderRadius: '8px',
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
          }}>
            {previewUrl ? (
              <img 
                src={previewUrl} 
                alt="Label Preview"
                style={{
                  width: '80mm',
                  height: '120mm',
                  objectFit: 'contain',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                }}
              />
            ) : (
              <div style={{ 
                color: '#999', 
                fontSize: '16px',
                textAlign: 'center',
                marginTop: '20px'
              }}>
                加载面单预览中...
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

export default OrderDetails;
